import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../Utility';

const initialState = {
    user: null,
    found: false,
    list: [],
    dataLoaded: false,
    trackingData: [],
    k12Data: []
};

const userFound = (state, action) => {
    return updateObject(state, { user: action.user, found: true });
}

const clearUserData = (state, action) => {
    return updateObject(state, { user: null, found: false });
}

const listCheckedInUsers = (state, action) => {
    return updateObject(state, { list: action.list });
}

const CSVDataLoaded = (state, action) => {
    return updateObject(state, { dataLoaded: true, trackingData: action.trackingData, k12Data: action.k12Data });
}

const unloadCSVData = (state, action) => {
    return updateObject(state, { dataLoaded: false, trackingData: [], k12Data: [] });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.USER_FOUND: return userFound(state, action);
        case actionTypes.USER_NOT_FOUND: return clearUserData(state, action);
        case actionTypes.CHECKED_IN: return clearUserData(state, action);
        case actionTypes.CHECKOUT_OUT: return clearUserData(state, action);
        case actionTypes.LIST_CHECKED_IN_USERS: return listCheckedInUsers(state, action);
        case actionTypes.CSV_DATA_UNLOADED: return unloadCSVData(state, action);
        case actionTypes.CSV_DATA_LOADED: return CSVDataLoaded(state, action);
        default: return state;
    }
}

export default reducer;